import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

import backgroundImage from '../assets/backgroundSky.jpeg';
import fernandaImg from '../assets/fernanda.jpeg';
import gabiImg from '../assets/gabi.jpeg';
import marcelaImg from '../assets/marcela.jpeg';
import rachelImg from '../assets/rachel.jpeg';

const MembroEquipe = ({ nome, cargo, descricao, foto, isReversed }) => {
  return (
    <motion.div
      className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-10 lg:gap-20 mb-24 last:mb-0`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.7 }}
    >
      {/* Foto com Moldura na cor principal #ff2d6c */}
      <div className="w-full lg:w-1/2 flex justify-center">
        <div className="relative group w-full max-w-[450px] lg:max-w-full">
          <div className="absolute inset-0 bg-[#ff2d6c] rounded-3xl rotate-2 group-hover:rotate-0 transition-transform duration-500 -z-10 shadow-lg opacity-80" />
          <img
            src={foto}
            alt={nome}
            className="w-full h-[380px] md:h-[500px] object-cover rounded-3xl shadow-xl transition-transform duration-500 group-hover:scale-[1.02] border-b-4 border-[#ff2d6c]/20"
          />
        </div>
      </div>

      {/* Descrição com detalhes na paleta Lily */}
      <div className="w-full lg:w-1/2 space-y-6 text-center lg:text-left">
        <div className="space-y-2">
          {/* Quote com a cor principal */}
          <Quote className="text-[#ff2d6c] w-12 h-12 opacity-30 mx-auto lg:mx-0 mb-2" />
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
            {nome}
          </h3>
          {cargo && (
            <div className="inline-block bg-[#ff2d6c]/10 border border-[#ff2d6c]/20 px-4 py-1 rounded-full">
              <span className="text-xs md:text-sm font-bold text-[#ff2d6c] uppercase tracking-[0.15em]">
                {cargo}
              </span>
            </div>
          )}
        </div>

        {/* Texto com borda lateral suave no tom ddb7c6 (o fim do seu gradiente) */}
        <p className="text-gray-800 text-lg md:text-xl leading-relaxed font-light italic lg:border-l-4 lg:border-[#ddb7c6] lg:pl-6">
          "{descricao}"
        </p>
      </div>
    </motion.div>
  );
};

const QuemSomos = () => {
  const meninas = [
    {
      nome: 'Rachel Marinho',
      cargo: 'CEO & Idealizadora',
      descricao:
        'Oi, eu sou a Rachel, tenho 22 anos e curso Direito na UFAM. Sou a mente por trás do Lily — aquela que pensa em tudo e faz acontecer. Cuido da parte estratégica, administrativa e de todas as decisões do clube.',
      foto: rachelImg,
    },
    {
      nome: 'Fernanda Marinho',
      cargo: 'COO & Área Criativa',
      descricao:
        'Oi, eu sou a Fernanda, tenho 21 anos e curso Medicina Veterinária 🐾 Atuo no design, na parte operacional e adoro transformar cada edição em algo especial. Sou viciada em suspense e na saga Crepúsculo 🖤.',
      foto: fernandaImg,
    },
    {
      nome: 'Gabriela Leocadia',
      cargo: '',
      descricao:
        'Oi, eu sou a Gabriela, tenho 22 anos e curso Direito. No Lily, garanto que tudo esteja funcionando direitinho. Cuido da logística e fofoca 👀 com a comunidade. Resolvo o que for preciso dos bastidores aos detalhes. ✨',
      foto: gabiImg,
    },
    {
      nome: 'Marcela Ramos',
      cargo: 'CMO & Experience Design',
      descricao:
        'Oi, eu sou a Marcela, tenho 21 anos e curso Arquitetura. No Lily, transformo cada edição em uma experiência única. Cuido dos registros, buffet e confeitaria, garantindo que tudo seja especial e inesquecível. ✨',
      foto: marcelaImg,
    },
  ];

  return (
    <section
      className="relative py-20 md:py-32 overflow-hidden bg-[#fff0f3]" // Um fundo levemente rosado em vez de branco puro
      id="quem-somos"
    >
      {/* Camada 1: A Imagem de Fundo (Céu) */}
      <div
        className="absolute inset-0 z-0 opacity-60" // Aumentei a opacidade para 60%
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'contrast(1.1) brightness(0.9) hue-rotate(320deg)', // Mais contraste e tom rosa
          mixBlendMode: 'multiply', // Faz a imagem se fundir com as cores abaixo
        }}
      />

      {/* Camada 2: Overlay de Gradiente Colorido (Aqui está a "cor" que você pediu) */}
      <div
        className="absolute inset-0 z-0 opacity-40"
        style={{
          background: 'linear-gradient(135deg, #e6dfe1 0%, #ddb7c6 100%)',
        }}
      />

      {/* Camada 3: Vinheta Suave (Para garantir que o texto continue legível) */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#fff0f3] via-transparent to-[#fff0f3]" />

      <div className="relative z-10 max-w-7xl mx-auto px-8 lg:px-12">
        {/* ... restante do conteúdo (Header e Map das meninas) ... */}

        <div className="text-center max-w-3xl mx-auto mb-24">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            className="inline-block mb-4 px-6 py-1 border border-[#ff2d6c]/40 rounded-full bg-white/60 backdrop-blur-md"
          >
            <span className="text-[#ff2d6c] text-xs font-bold uppercase tracking-widest">
              Nosso Time
            </span>
          </motion.div>
          <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
            As mentes por trás do <span className="text-[#ff2d6c]">Lily</span>
          </h2>
        </div>

        <div className="space-y-24 md:space-y-32">
          {meninas.map((menina, index) => (
            <MembroEquipe
              key={index}
              {...menina}
              isReversed={index % 2 !== 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuemSomos;
